import target from './target';
import items from './items';
import studentInfo from './studentInfo';
import studentState from './studentState';
import studentResult from './studentResult';
import auth from './auth';
import teacherModal from './teacherModal';
import studentAudit from './studentAudit';
import teacherInfo from './teacherInfo';
import teacherState from './teacherState';
import teacherResult from './teacherResult';
import teacherAudit from './teacherAudit';
import teacherReport from './teacherReport';
import studentReport from './studentReport';

export default {
    target,
    items,
    studentInfo,
    studentState,
    studentResult,
    auth,
    teacherModal,
    studentAudit,
    teacherInfo,
    teacherState,
    teacherResult,
    teacherAudit,
    teacherReport,
    studentReport
}